// extracted by mini-css-extract-plugin
export default {"wrapper":"TextValue_wrapper__WvVY4","label":"TextValue_label__Xmisf","value":"TextValue_value__P9s35"};